import React from 'react';

import { TabNav } from '@repo/ui/Tabs';
import { NavTab } from '@repo/ui/Tabs';
import { useAccount } from '@/hooks/useAccount';

const SettingsTabNav = () => {
  const currentAccount = useAccount();

  const SettingsTabs: NavTab[] = [
    {
      title: 'User profile',
      href: `/a/${currentAccount?.id}/user-settings/profile`,
    },
    {
      title: 'Security',
      href: `/a/${currentAccount?.id}/user-settings/security`,
    },
    {
      title: 'Appearance',
      href: `/a/${currentAccount?.id}/user-settings/appearance`,
    },
  ];

  return <TabNav tabs={SettingsTabs} />;
};

export default SettingsTabNav;
